import { REDUX_CLASS_NAME_TO_DOMAIN } from 'modules/redux/constants'
import { getDomainMapValueReduxUtil } from 'modules/redux/utils/get-domain-map-value'
import { CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'
import { getObjectUtil } from 'packages/src'

/**
 * Gets the path of the given `instance`.
 * If it's a temporary instance and it has no `domainMapValue`,
 * its temporary id will be used.
 *
 * @param  {Instance} instance
 * @param  {string} [domainPath]
 * @returns {string}
 */
function getPathReduxUtil (instance, domainPath) {
  if (!instance) {
    return
  }
  const { className } = instance
  const domainName = domainPath || REDUX_CLASS_NAME_TO_DOMAIN[className]
  if (!domainName) {
    console.warn('domain name does not exist for instance: ', instance)
    console.warn('REDUX_CLASS_NAME_TO_DOMAIN=', REDUX_CLASS_NAME_TO_DOMAIN)
  }

  const domainMapValue = getDomainMapValueReduxUtil(instance, domainPath)
  if (!domainMapValue) {
    return domainName
  }

  if (className === CATEGORY_MODEL_CLASS_NAME) {
    const sectionName = getObjectUtil(instance, 'data.section.data.name')
    if (sectionName) {
      return `${domainName}.${sectionName}.data.${domainMapValue}`
    }
  }
  return `${domainName}.data.${domainMapValue}`
}

export default getPathReduxUtil
